import { AppState } from "@/mk2/reducers";
import { BlogPostEntity, BlogPostSchema } from "@/mk2/schemas";
import { findDenormalizedEntityByCond } from "@/mk2/selectors";

export const findBlogPost = (state: AppState, postSlug: string): BlogPostEntity =>
    findDenormalizedEntityByCond(
        state,
        BlogPostSchema,
        `cacheKey-${findBlogPost.name}-${postSlug}`,
        (normalizedPost: any) => normalizedPost.slug === postSlug,
    );

export const findGroupPost = (state: AppState, groupId: number, postSlug: string): BlogPostEntity =>
    findDenormalizedEntityByCond(
        state,
        BlogPostSchema,
        `cacheKey-${findGroupPost.name}-${groupId}-${postSlug}`,
        (normalizedPost: any) =>
            normalizedPost.group === groupId && normalizedPost.slug === postSlug,
    );
